import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useSelector } from 'react-redux';
import { baseUrl } from "../../shared/baseUrl";
import { NavLink, useNavigate} from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import ReactPaginate from "react-paginate";
import TableHandler from '../../components/admin/TableHandler';
import { MdDelete } from 'react-icons/md';
import Swal from 'sweetalert2';

const AllAgents = () => {
  const navigate = useNavigate()

  const [toggleNav, setToggleNav] = useState(false)
  
  const [data, setData] = useState([])
  const [dataXY, setDataXY] = useState([])
  const [searchXY, setSearchXY] = useState("")

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0)
  const itemsPerPage = 10
  const pagesVisited = pageNumber * itemsPerPage
  const pageCount = Math.ceil(data?.length / itemsPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)
  const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
  // --- Pagination --- //

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userInfo?.token}`
    }
  }

  useEffect(() => {
    document.title = "Island Luxury - All Agents"
    if(!userInfo) {
			navigate('/')
		} else {
      const getAgents = async () => {
        try {
          setLoading(true)
          const res = await axios.get(baseUrl + "/api/v1/users", config)
          setLoading(false)
          setData(res.data.data)
          setDataXY(res.data.data)
        }
        catch(err){
          setLoading(false)
          setError(err.response && err.response.data.message ? err.response.data.message : err.message)
        }
      }
      getAgents()
    }
  }, [userInfo, navigate])

  
  // --- Search Cycle Handler --- //
  useEffect(() => {
    const results = dataXY?.filter(item => (
      item?.email.toLowerCase().includes(searchXY) || 
      item?.username.toLowerCase().includes(searchXY)
    ))
    setData(results)
  }, [searchXY, dataXY])


  // --- Handle Delete User --- //
  const handleDeleteAgent = (item) => {
    const deleteUser = async () => {
      try {
        await axios.delete(baseUrl + `/api/v1/users/${item._id}`, config)
        Swal.fire({
          icon: 'success',
          title: 'Delete',
          text: `You have deleted ${item.firstname} ${item.lastname}, please refresh!`,
        })
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}, please try again!`,
        })
      }
    }
    deleteUser(item._id)
  }

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="my-listing">
        <section className="page-title">
          <h3><NavLink to="/dashboard">Dashboard</NavLink> | Registered Agents</h3>
        </section>
        <section className="my-listing_cont">
          <div className="table-search_area">
            <div>
              <form>
                <input type="text" placeholder="Search Email or Username" value={searchXY} onChange={(e) => setSearchXY(e.target.value)} />
              </form>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Username</th>
                <th>Role</th>
                <th>Suscription</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading && displayData.map((item, index) =>
                <tr key={index}>
                  <td>{item.firstname} {item.lastname}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td>{item.username}</td>
                  <td>{item.role === "estate-agent" ? "Estate Agent" : "Admin"}</td>
                  <td>
                    <div>
                      {item.subscriptionPlan}
                    </div>
                  </td>
                  <td className="table-action">
                    <button className="del" title="Delete Agent" onClick={() => handleDeleteAgent(item)}>
                      Del <MdDelete size={20} />
                    </button>
                  </td>
                </tr> 
              )}
            </tbody>
          </table>

          <TableHandler data={data} loading={loading} error={error} />

          {data?.length > itemsPerPage &&
            <div className="pagination-tab">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"} />
            </div>
					}
        </section>
      </main>
    </div>
  )
}

export default AllAgents;